import moment from 'moment'

export const shouldReauthenticate = (lastAuthenticated: number = 0) => {
  const lastAuth = lastAuthenticated * 1000
  const threeDaysAgo = moment().utc().valueOf() - 3 * 24 * 60 * 60 * 1000
  const hasAuthenticatedInLastThreeDays = lastAuth > threeDaysAgo
  return !hasAuthenticatedInLastThreeDays
}
